export default {
  actionButtons: {
    submit: "Create Digital Twin",
    supportChatButtonText: "Chat with support",
  },
  addressStep: {
    fetchAddressButton: "Find Address",
    fetchLocationButton: "Find Building On Map",
    fields: {
      address: {
        label: "Street and number",
        placeholder: "Street and number",
      },
      city: {
        label: "City",
        placeholder: "City",
      },
      country: {
        label: "Country",
        placeholder: "Country",
      },
      name: {
        label: "Building name",
        placeholder: "e.g., Office Building A",
      },
      postal_code: {
        label: "Postal code",
        placeholder: "Postal code",
      },
    },
    geocode: {
      addressError: "Could not find an address for this location.",
      addressSuccess: "Address updated from map location.",
      emptyAddressError: "Please enter an address.",
      locationError: "Could not find a location for this address.",
      locationSuccess: "Location updated from address.",
    },
    infoBannerMessage:
      "Enter the building address, then use the buttons to sync the form and map. Make sure the location marker is placed correctly before continuing.",
    search: {
      noResults: "No matching places",
      placeholder: "Search for a place",
    },
    title: "Building Address",
  },
  buildingDetailsStep: {
    coolingQuestion: "Are parts of the building cooled?",
    coolingTitle: "Cooling",
    elements: {
      facade: "Facade",
      rooftop: "Rooftop",
      windows: "Windows",
    },
    heatingOptions: {
      district_heating: "District heating",
      electric: "Electric",
      gas_boiler: "Gas boiler",
      heat_pump: "Heat pump",
      oil_boiler: "Oil boiler",
      other: "Other",
    },
    heatingSystemLabel: "What heating system is being used?",
    heatingSystemPlaceholder: "Select heating system",
    installationDateLabel: "When has it been installed?",
    mechanicalVentilationQuestion: "Does the building use mechanical ventilation?",
    mechanicalVentilationTitle: "Mechanical ventilation",
    modernizationsQuestion: "Were there any modernizations on windows, facade or rooftop?",
    modernizationsTitle: "Modernizations",
    modernizationSubheading: "Select elements and modernization year",
    pvQuestion: "Does the building have a PV system?",
    pvTitle: "PV system",
    sectionHeating: "Heating system",
    skipStep: "Skip this step",
    subtitle: "Provide information about heating, modernizations, ventilation, cooling, and PV systems.",
    title: "Building details",
    yearPickerPlaceholder: "e.g., 1995",
  },
  energyAnalysisStep: {
    cards: {
      bills: {
        description: "Upload energy data or bills (all file types accepted).",
        title: "Bills",
      },
      buildingPlans: {
        description: "Upload architectural plans, rescue plans, side views, cuts, and 3D models.",
        title: "Building plans",
      },
      energyCertificate: {
        description: "Upload one or multiple Energy Performance Certificates (PDF or images).",
        title: "Energy certificate",
      },
      otherDocuments: {
        description: "Upload any additional documents that may be relevant.",
        title: "Other documents",
      },
      technicalData: {
        description: "Upload technical data on heating, ventilation, PV, luminance, and more.",
        title: "Technical data",
      },
    },
    subtitle:
      "Upload related documents to receive a more accurate analysis (energy certificates, bills, plans, technical data, or other files; multiple uploads supported, no ZIP).",
    title: "Energy & Analysis",
  },
  epcModal: {
    acceptedFormats: "Accepted formats: ",
    analyzingMessage: "Analyzing your EPC...",
    analyzingTitle: "Processing",
    applyButton: "Use this data ",
    error: {
      extractionFailed: "Failed to extract data from the energy certificate. Please try again or continue without it.",
    },
    extractingFile: "Extracting certificate data...",
    infoBannerMessage:
      "This is optional. If you upload an energy certificate, we will try to fill information for you.",
    introDescription:
      "Upload your Energy Performance Certificate and we'll automatically extract building details to speed up your setup.",
    introFooter: "You can always upload an EPC later.",
    introSkipButton: "No, enter manually",
    introTitle: "Have an Energy Performance Certificate?",
    introUploadButton: "Yes, upload my EPC",
    openButton: "Upload energy certificate",
    optionalBadge: "optional",
    preview: {
      additionalInformationVoluntary: "Additional voluntary information",
      additionalTitle: "Additional EPC Information",
      assessor: "Assessor",
      buildingName: "Building name",
      buildingPart: "Building part (certificate)",
      buildingType: "Building type",
      buildingVolume: "Building volume",
      co2Emissions: "CO₂ emissions",
      dataCollectedByAssessor: "Data collected by assessor",
      dataCollectedFromOwner: "Data collected from owner",
      energyConsumption: {
        finalEnergyConsumption: "Final energy consumption",
        finalEnergyConsumptionForPropertyAdvertisements: "Final energy consumption (advertisements)",
        primaryEnergyConsumption: "Primary energy consumption",
      },
      energyConsumptionCertificate: "Energy consumption certificate",
      energyDemandCertificate: "Energy demand certificate",
      energyEfficiencyClass: "Energy efficiency class",
      enev: {
        buildingEnvelopeHtActual: "Building envelope Hₜ (actual)",
        buildingEnvelopeHtRequirement: "Building envelope Hₜ (requirement)",
        primaryEnergyDemandActual: "Primary energy demand (actual)",
        primaryEnergyDemandRequirement: "Primary energy demand (requirement)",
      },
      enevTightenedPercent: "EnEV tightened %",
      finalEnergyDemand: "Final energy demand",
      finalEnergyDemandTable: "Final energy demand table",
      footprintArea: "Footprint area (m²)",
      heatingConsumptionRecord: {
        climateFactor: "Climate factor",
        energyConsumptionKwh: "Energy consumption",
        energySource: "Energy source",
        from: "From",
        heatingShareKwh: "Heating share",
        hotWaterShareKwh: "Hot water share",
        primaryEnergyFactor: "Primary energy factor",
        to: "To",
      },
      heatingConsumptionRecords: "Heating & hot water consumption record",
      heatingSystem: "Heating system",
      hotWater: "Hot water",
      issueDate: "Issue date",
      issuer: "Issuer",
      livingAreaRegulation: "Living area per regulation",
      prefillTitle: "Will be used in setup",
      primaryEnergyDemand: "Primary energy demand",
      procedureCheckboxes: "Procedure checkboxes",
      reasonForIssue: "Reason for issue",
      renewableEnergy: "Renewable energy",
      renewableEnergyType: "Renewable energy type",
      renewableEnergyUsage: "Renewable energy share",
      sections: {
        additionalData: "Additional certificate data",
        buildingDetails: "Building details",
        buildingEnvelope: "Building envelope",
        buildingSystems: "Building systems",
        certificateDetails: "Certificate details",
        consumption: "Energy consumption",
        energyPerformance: "Energy performance",
        heatingConsumptionRecords: "Heating & hot water consumption records",
      },
      streetAndNumber: "Street & number",
      substituteMeasures: "Substitute measures",
      substituteMeasuresInfo: "Substitute measures — additional info",
      tightenedBuildingEnvelopeHt: "Tightened building envelope Hₜ",
      tightenedPrimaryEnergyDemand: "Tightened primary energy demand",
      title: "EPC Data Found",
      uploadedFilename: "Source file",
      validFrom: "Valid from",
      validUntil: "Valid until",
      ventilation: "Ventilation",
      ventilationCooling: "Ventilation & cooling (certificate text)",
      windows: "Windows",
    },
    previewSubtitle: "Review the extracted information before applying it to the form.",
    reuploadButton: "Change energy certificate",
    selectFileFirst: "Please choose a file first.",
    skipButton: "Continue without certificate",
    subtitle: "Upload your Energy Performance Certificate (EPC) to automatically fill information.",
    title: "Energy Performance Certificate",
    uploadAndExtract: "Upload & extract",
    uploadingMessage: "Uploading your certificate...",
    uploadingTitle: "Uploading",
    uploadScreenSubtitle: "Drag and drop your certificate here, or browse to select a file.",
    uploadScreenTitle: "Upload EPC",
    uploadTitle: "Energy certificate",
  },
  finalStep: {
    addAnotherBuilding: "Add another building",
    defaultBuildingName: "your building",
    goToProfile: "Go to Building Profile",
    status: {
      analysesCount: "2",
      analysesQueued: "Analyses queued",
      completedValue: "Completed",
      estCompletion: "Est. completion",
      estTime: "~5 min",
      failedValue: "Failed",
      processingLabel: "Status",
    },
    subtitle: "Your Digital Twin for {{buildingName}} is ready. You can now view detailed insights and analysis.",
    tiers: {
      heading: "What's next?",
      plus: {
        cta: "Choose Plus",
        description: "Enhanced analytics, deeper benchmarks, and priority support when you need answers fast.",
        features: {
          advancedEnergy: "Advanced energy modeling",
          customDashboards: "Custom dashboards",
          prioritySupport: "Priority support",
        },
        title: "Digital Twin Plus",
      },
      premium: {
        cta: "Choose Premium",
        description: "Real-time monitoring, AI-powered recommendations, and a dedicated success partner.",
        features: {
          aiOptimization: "AI-powered optimization",
          dedicatedManager: "Dedicated success manager",
          realtimeMonitoring: "Real-time monitoring & alerts",
        },
        title: "Digital Twin Premium",
      },
      pv: {
        cta: "Explore PV potential",
        description:
          "From initial assessment to detailed planning — calculate solar panel capacity and yield with hour-based shading analysis.",
        features: {
          profitabilityAssessment: "Profitability & ROI assessment",
          shadingAnalysis: "Hour-based shading analysis",
          yieldSimulation: "Yield & capacity simulation",
        },
        title: "PV Potential Analysis",
      },
      subtitle: "While we are getting things ready for you, would you like to explore our more detailed options",
      title: "",
    },
    title: "Digital Twin created!",
  },
  layersStep: {
    addLayer: "Add layer",
    addLayerHint: "Choose a layer type (or a custom name), then add it to the stack.",
    addNamedSubLayer: "Add sublayer",
    addSubLayer: "Add sublayer",
    areaFootprint: "Footprint area:",
    areaSite: "Site area:",
    customLayerNameLabel: "Layer name",
    customLayerNamePlaceholder: "e.g. Parking deck",
    customSubLayerOption: "Custom name",
    customSubLayerPlaceholder: "Custom sublayer name",
    drawToolbar: {
      deleteObject: "Delete object",
      draw: "Draw object",
      editPoints: "Edit points",
    },
    infoToast:
      "Select a layer and sublayer on the right, then draw. Only objects on the active sublayer are shown on the map.",
    layerPresetLabels: {
      custom: "Custom layer",
      rooftop_objects: "Rooftop objects",
      vegetation: "Vegetation",
    },
    layerTypeLabel: "Layer type",
    noObjectsDrawNew: "No objects yet. Draw a new object.",
    noObjectsYet: "No objects yet — draw on the map with this sublayer selected.",
    objectDefault: "Object {{n}}",
    sublayerDefault: "Sublayer {{n}}",
    sublayerPresetHint: "Add a sublayer from the preset list, or type a custom name.",
    sublayerPresetLabels: {
      rooftop_objects: {
        antenna: "Antenna",
        chimney: "Chimney",
        hvac: "HVAC",
        obstacle: "Obstacle",
        other: "Other",
        skylight: "Skylight",
        solar_panel: "Solar panel",
        vent: "Vent",
      },
      vegetation: {
        trees: "Trees",
      },
    },
    sublayerSelectAria: "Active sublayer",
    sublayersHeading: "Sublayers & objects",
    subtitle: "Draw shapes on layers to mark obstacles for PV panel placement.",
    title: "Rooftop objects",
  },
  ldsToast: {
    undo: "Undo",
  },
  outlineStep: {
    delete: "Delete",
    drawOutline: "Draw outline",
    editPoints: "Edit points",
    errorToast: "There was an error detecting the outline!",
    finishDrawing: "Finish Drawing",
    footprintArea: "Footprint area:",
    hints: {
      finish: "Double-click or press Enter to finish the outline",
      place: "Click on the map to place corner points",
      start: 'Click "Draw outline" to start drawing',
    },
    infoToast: "The outline doesn't need to be perfect. You can adjust it later in the building profile.",
    mapLoadingText: "Automatically detecting outline ...",
    siteArea: "Site area:",
    subtitle:
      "Use the drawing tools to outline the building footprint on the map. This will help us calculate the available roof area.",
    title: "Draw the building outline",
    unitsM2: "m²",
  },
  prefillingFormDataLoadingText: "Loading data...",
  singleBuildingStepper: {
    stepName: {
      address: "Address",
      buildingDetails: "Building details",
      buildingOutline: "Building outline",
      buildingSummary: "Building summary",
      energyAndAnalysis: "Energy & analysis",
      rooftopObjects: "Rooftop objects",
    },
  },
  submitModal: {
    action: {
      cancel: "Cancel",
      close: "Close",
    },
    deletedImagesLabel: "Deleting images",
    error: {
      failedToDeleteImage: "Failed to delete image. Please try again.",
      failedToSubmit: "Failed to submit the building. Please try again.",
      failedToSubmitInfo: "Failed to submit the building information",
      jobAlreadyInProgress: "A job has already been submitted.",
    },
    filesLabel: "Uploading files",
    imagesLabel: "Uploading images",
    rows: {
      projectCreationLabel: "Creating project",
      projectUpdateLabel: "Updating project",
      submitBuildingInfo: "Submitting building information",
    },
    title: "Submitting data",
  },
  summaryStep: {
    buildingTypeLabel: "Building type",
    buildingTypeLabels: {
      education: "Education",
      healthcare: "Healthcare",
      hospitality: "Hospitality",
      hotel: "Hotel",
      industrial: "Industrial",
      logistics: "Logistics",
      mixed: "Mixed use",
      office: "Office",
      other: "Other",
      residential: "Residential",
      retail: "Retail",
    },
    buildingTypePlaceholder: "Select building type",
    detailsInfoToast:
      "These details help our analysis engine provide more accurate recommendations for energy optimization.",
    detailsSubtitle: "Provide core metadata about your building to create an accurate Digital Twin.",
    detailsTitle: "Building Details",
    fields: {
      constructionYear: {
        label: "Year of construction",
        placeholder: "e.g., 1995",
      },
      floors: {
        label: "Number of floors",
        placeholder: "e.g., 4",
      },
      rentalUnits: {
        label: "Number of rental units",
        placeholder: "e.g., 3500",
      },
    },
    mixConfigurationTitle: "Mix configuration",
    mixEdit: "Edit",
    mixEmptyHint: "No mix percentages set yet. Click Edit.",
    mixModal: {
      cancel: "Cancel",
      errorTotal: "Total percentage must equal 100%",
      rowLabel: "{{type}}:",
      save: "Save mix",
      subtitle: "Specify the percentage allocation for each building type. Total must equal 100%.",
      title: "Configure mixed building type",
      totalLabel: "Total",
    },
    summaryRows: {
      address: "Address",
      assetId: "Asset ID",
      assetName: "Asset name",
    },
    summarySubtitle: "Here's the building summary. You can also upload one or more photos below.",
    summaryTitle: "Building Summary",
    upload: {
      browse: "Browse",
      removeFile: "Remove {{name}}",
      uploadLabel: "Upload",
    },
    uploadAreaAria: "Upload building photos",
  },
};
